/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';

import { Images } from '../../../assets';
import { Flex } from '../../../components/Flex';
import { AtiraLink } from '../../../model/atira-link/AtiraLink';
import { CreateAtiraLinkDto } from '../../../model/atira-link/dto/CreateAtiraLinkDto';
import { EditAtiraLinkDto } from '../../../model/atira-link/dto/EditAtiraLinkDto';
import { AtiraLinkLang } from '../../../model/settings/types/AtiraLinkLang.enum';
import { Breakpoints } from '../../../theme/Breakpoints';
import { Spacing } from '../../../theme/Spacing';
import { TemplatePreviewMode } from '../../shared/model/TemplatePreviewMode.enum';
import { getEJSWrapperWidthHeight } from '../utils/getEJSWrapperWidthHeight';
import { AtiraLinkPreviewPhoneEJS } from './AtiraLinkPreviewPhoneEJS';

const Container = styled(Flex)<{
  isPreviewMode: boolean;
  previewMode: TemplatePreviewMode;
}>`
  flex-direction: column;
  align-items: center;
  position: sticky;
  top: ${Spacing.m};
  margin-inline: ${({ isPreviewMode }) => (!isPreviewMode ? Spacing.s : '')};
  overflow: hidden;

  ${({ isPreviewMode }) =>
    isPreviewMode
      ? `
    @media (max-width: ${Breakpoints.TABLET}) {      
      .atira-link-body {
        min-height: 70vh;
      }
    }
  `
      : ``}
`;

const PhoneWrapper = styled(Flex)<{
  isPreviewMode: boolean;
  previewMode: TemplatePreviewMode;
}>`
  position: relative;
  flex-direction: column;
  background-color: transparent;
  overflow: hidden;
  display: ${({ isPreviewMode }) => (isPreviewMode ? 'flex' : 'none')};

  @media (min-width: ${Breakpoints.DESKTOP}) {
    display: flex;
  }
`;

const PhoneFrameWrapper = styled(Flex)<{
  previewMode: TemplatePreviewMode;
  isPreviewMode: boolean;
}>`
  position: relative;
  z-index: 1;
  width: ${({ previewMode, isPreviewMode }) =>
    isPreviewMode
      ? previewMode === TemplatePreviewMode.MOBILE
        ? '280px'
        : previewMode === TemplatePreviewMode.TABLET
          ? '650px'
          : '1100px'
      : '250px'};
  aspect-ratio: ${({ previewMode }) =>
    previewMode === TemplatePreviewMode.MOBILE
      ? '  59 / 125'
      : previewMode === TemplatePreviewMode.TABLET
        ? '  475 / 363'
        : '2489 / 1421'};
  overflow: hidden;

  &::after {
    content: '';
    background-image: ${({ previewMode }) =>
      previewMode === TemplatePreviewMode.MOBILE
        ? `url(${Images.PreviewMobile})`
        : previewMode === TemplatePreviewMode.TABLET
          ? `url(${Images.PreviewIpad})`
          : `url(${Images.PreviewDesktop})`};
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    z-index: 1025;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  .ejs-wrapper {
    overflow: hidden;
    width: ${({ previewMode }) => getEJSWrapperWidthHeight(previewMode).width};
    height: ${({ previewMode }) =>
      getEJSWrapperWidthHeight(previewMode).height} !important;
    margin-inline: auto;
    margin-block: ${({ previewMode }) =>
      previewMode !== TemplatePreviewMode.DESKTOP ? 'auto' : '0'};

    ${({ previewMode }) =>
      previewMode === TemplatePreviewMode.DESKTOP
        ? `
        margin-top: 33px;
      `
        : ''}

    ${({ previewMode }) =>
      previewMode === TemplatePreviewMode.MOBILE
        ? `
      border-radius: 8px;
    `
        : ''}
  }
`;

interface AtiraLinkPreviewPhoneProps {
  values: (
    | CreateAtiraLinkDto
    | EditAtiraLinkDto
    | AtiraLink
    | Partial<AtiraLink>
  ) & {
    linkName: string;
  };
  currentLinkLang?: AtiraLinkLang;
  loading?: boolean;
  setLoading?: ATVoidFunction<boolean>;
  isPreviewMode?: boolean;
  previewMode?: TemplatePreviewMode;
}

export const AtiraLinkPreviewPhone: React.FC<AtiraLinkPreviewPhoneProps> = ({
  values,
  currentLinkLang,
  isPreviewMode = false,
  previewMode = TemplatePreviewMode.MOBILE,
}) => {
  return (
    <Container isPreviewMode={isPreviewMode} previewMode={previewMode}>
      <PhoneWrapper isPreviewMode={isPreviewMode} previewMode={previewMode}>
        <PhoneFrameWrapper
          previewMode={previewMode}
          isPreviewMode={isPreviewMode}
        >
          <AtiraLinkPreviewPhoneEJS
            isPreviewMode={isPreviewMode}
            atiraLink={values}
            currentLinkLang={currentLinkLang}
            previewMode={previewMode}
          />
        </PhoneFrameWrapper>
      </PhoneWrapper>
    </Container>
  );
};
